module.exports = __webpack_public_path__ + "static/media/Categorized_content_poster.34a8e38f.jpg";